<template>
  <div>
    <div id="modal-conversion" ref="modal" class="modal" :class="{'is-active': isActive }">
      <div @click="hideModal" class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">How to calculate conversion rate</p>
          <button @click="hideModal" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <!-- Content ... -->
          <h3 class="is-size-4">Definition</h3>
          <p>The conversion rate is the percentage of users who take a desired action. The archetypical example of conversion rate is the percentage of website visitors who buy something on the site.</p>
          <br />
          <h3 class="is-size-4">What is a good website conversion rate?</h3>
          <p>Across industries, the average landing page conversion rate was 2.35%, yet the top 25% are converting at 5.31% or higher. </p>
          <br />
          <img src="@/assets/conversion-rate-by-industry.png" alt="cvr by industry">
          <br />
        </section>
        <footer class="modal-card-foot">
          <!-- <button class="button is-success">Save changes</button> -->
          <button @click="hideModal" class="button">Cancel</button>
        </footer>
      </div>
    </div>
    </div>
</template>

<script>
export default {
  props: ['isActive'],
  methods: {
    hideModal () {
      let element = document.getElementById('modal-conversion')
      element.classList.remove('is-active')
    }
  }
}
</script>
